import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { canView as pCanView, canEdit as pCanEdit, canDetail as pCanDetail, canDelete as pCanDelete, keyForPath } from "../lib/perms";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(false); setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("token"); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
  };

  const can = (...roles) => {
    if (!user) return false;
    const er = user.effective_roles || [user.role];
    if (er.includes("owner")) return true;
    if (roles.length && roles.some((r) => er.includes(r))) return true;
    // Fallback granular: bila user punya izin EDIT pada menu halaman saat ini,
    // izinkan tombol tulis (menormalkan gating berbasis nama role builtin -> Custom Role).
    if (roles.length) {
      try {
        const key = keyForPath(window.location.pathname);
        if (key && pCanEdit(user, key)) return true;
      } catch (e) { /* ignore */ }
    }
    return false;
  };
  const canView = (key) => pCanView(user, key);
  const canEdit = (key) => pCanEdit(user, key);
  const canDetail = (key) => pCanDetail(user, key);
  const canDelete = (key) => pCanDelete(user, key);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, canView, canEdit, canDetail, canDelete }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
